import { WEBSOCKET_URL } from '../helpers/constants';
import axios from 'axios';
import { getMessages } from './messagesApi';

const TOPIC_URL = WEBSOCKET_URL + '/topic';

export const createTopic = async ({ freeUserId, paidUserId, title }) => {
  const response = await axios.post(TOPIC_URL, {
    freeUserId,
    paidUserId,
    title,
  });
  return response.data;
};

export const getTopicList = async params => {
  const response = await axios.get(TOPIC_URL, {
    params,
  });
  console.log(response.data);

  return response.data;
};

export const getTopic = async topicId => {
  const response = await axios.get(TOPIC_URL + `/${topicId}`);
  return response.data;
};

export const updateTopic = async ({ topicId, data }) => {
  const response = await axios.put(TOPIC_URL + `/${topicId}`, data);
  return response.data;
};

export const updateTopicAmount = async (topicId, senderId) => {
  const response = await axios.put(TOPIC_URL + `/${topicId}/amount`, {
    senderId,
  });
  return response.data;
};

export const deleteTopic = async ({ topicId }) => {
  const response = await axios.delete(TOPIC_URL + `/${topicId}`);
  return response.data;
};
